import { jsx as _jsx } from "react/jsx-runtime";
import { useLocation, useRoutes } from 'react-router-dom';
import { simRoutes } from 'console/sim/routes';
import { billingRoutes } from 'console/billing/routes';
import { z3k_settings_routes } from 'z3k-settings/routes';
import { master_settings_routes } from 'pages/settings-master/model';
import { new_devices_routes } from 'pages/device.add/model';
import { dasboard_settings_routes } from 'console/dashboards/z3k/settings/routes';
import { smartConfigRoutes } from 'console/smart-config/components/router';
import { AnimatePresence } from 'framer-motion';
import { interactive_board_routes } from 'console/shared/components/widgets/interactive-board/config/routes';
import { useNavigateRoot } from 'shared/hooks/router';
import { account_dialog_routes } from 'pages/account.settings/model';
import { ErrorBoundary, ErrorBoundaryView } from 'shared/components/error-boundary';
import { support_routes } from 'widgets/support.chat/model';
import { keyboard_shortcuts_routes } from 'pages/keyboard-shortcuts/model/routes';
import { debug_routes } from 'console/utils/debug-me';
export function RoutedElements(props) {
    const { children } = props;
    const location = useLocation();
    const navigate = useNavigateRoot();
    const dialogs = {
        path: '/',
        element: children,
        children: [
            ...simRoutes,
            ...billingRoutes,
            ...master_settings_routes,
            ...new_devices_routes,
            ...z3k_settings_routes,
            ...dasboard_settings_routes,
            ...smartConfigRoutes,
            ...account_dialog_routes,
            ...support_routes,
            ...keyboard_shortcuts_routes,
            ...debug_routes,
        ].map((item) => ({
            ...item,
            element: _jsx(ErrorBoundary, { children: item.element }),
            children: item.children?.map((child) => ({
                ...child,
                element: _jsx(ErrorBoundary, { children: child.element }),
            })),
        })),
    };
    const not_found = {
        path: '*',
        element: (_jsx(ErrorBoundaryView, { title: "\u0423\u043F\u0441... \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430 404", onClick: navigate })),
    };
    const element = useRoutes([dialogs, not_found, interactive_board_routes(children)], location);
    return (_jsx(AnimatePresence, { exitBeforeEnter: true, initial: false, children: element }));
}
